module.exports = __webpack_public_path__ + "assets/img/pic_02.645ae0e9.png";